import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const Container = styled.div`
  display: none;
  ${media.desktopSmall} {
    display: block;
    width: ${rem(280)};
    flex-shrink: 0;
    padding-top: ${rem(8)};
  }
  & > div {
    margin-bottom: ${rem(40)};
    border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.beerus[100]};
    padding-bottom: ${rem(40)};
    &:last-of-type {
      border: 0;
      padding-bottom: 0;
    }
  }
`;

export default Container;
